import { render } from "./RegistrationPaymentRequestsNew.vue?vue&type=template&id=e5eda8a4&scoped=true"
import script from "./RegistrationPaymentRequestsNew.vue?vue&type=script&lang=js"
export * from "./RegistrationPaymentRequestsNew.vue?vue&type=script&lang=js"

import "./RegistrationPaymentRequestsNew.vue?vue&type=style&index=0&id=e5eda8a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5eda8a4"]])

export default __exports__